import React, { Component } from 'react'
import { Label } from 'reactstrap'
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import ModalForm from '../../comum/components/ModalForm'
import { observer } from 'mobx-react'
import LoadingImage from '../../comum/components/LoadingImage';
import ExportarDadosExcel from "../../comum/components/ExportarDadosExcel"

@observer
export default class ModalDados extends Component {
    
    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }
    
    render() {
        return (
            <ModalForm
                className="modal-dados"
                esconderSalvar={true}
                onClickCancelar={this.controller.fecharModalItem}
                labelCancelar="FECHAR"
            >
                <h2>
                    {this.controller.modalTitulo}
                </h2>
                <Label className="mensagem-filtrar">
                    {this.controller.modalCategoria}
                </Label>
                {this.controller.loadingModal
                ?<LoadingImage />
                :
                <React.Fragment> 
                    <ToolkitProvider
                            keyField="IdView"
                            data={[...this.controller.itensModal]}
                            columns={[...this.controller.colunasModal]}
                        >
                        {
                            props => <div className="modal-dados__tabela-container">
                                <div className="modal-dados__tabela">
                                    <BootstrapTable bootstrap4
                                        striped
                                        bordered={false}
                                        classes="tabela tabela-layout cabotagem"
                                        noDataIndication={() => this.controller.tableMessage}
                                        {...props.baseProps}
                                    />
                                </div>
                            </div>
                        }
                    </ToolkitProvider>
                    <div className="mt-2 d-flex flex-row align-items-center justify-content-center">
                        <ExportarDadosExcel filename={`${this.controller.modalCategoria}.xlsx`}
                                            lista={[...this.controller.itensModal]}
                                            colunas={this.controller.colunasModal}
                                            buttonText="Baixar XLS"
                                            desabilita={false}
                        />
                    </div>
                </React.Fragment>
                }
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/meutecon/components/ModalDados.js